import React, { useState, useEffect } from 'react';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import { Link } from 'react-router-dom';
import { PlusIcon, XMarkIcon, PencilIcon, TrashIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const SocietaNoleggioGaranzie = () => {
  const [garanzie, setGaranzie] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [currentGaranzia, setCurrentGaranzia] = useState(null);
  const [formData, setFormData] = useState({ descrizione: '', attivo: true });
  const [errors, setErrors] = useState({});
  const [notification, setNotification] = useState({
    show: false,
    message: '',
    type: 'success',
    timeout: null
  });

  // Recupera l'elenco delle garanzie
  const fetchGaranzie = async () => {
    try {
      setLoading(true);
      const response = await api.get('/noleggio/garanzie');
      setGaranzie(response.data || []);
      setLoading(false);
    } catch (err) {
      console.error('Errore nel recupero delle garanzie:', err);
      setLoading(false);
      showNotification('Errore nel recupero delle garanzie', 'error');
    }
  };

  // Carica le garanzie all'avvio del componente
  useEffect(() => {
    fetchGaranzie();
  }, []);

  // Funzione per mostrare una notifica
  const showNotification = (message, type = 'success') => {
    // Clear any existing timeout
    if (notification.timeout) {
      clearTimeout(notification.timeout);
    }
    
    // Set the notification
    setNotification({
      show: true,
      message,
      type,
      timeout: setTimeout(() => {
        setNotification(prev => ({ ...prev, show: false }));
      }, 3000)
    });
  };

  // Funzione per aprire il form di creazione
  const handleCreate = () => {
    setCurrentGaranzia(null);
    setFormData({ descrizione: '', attivo: true });
    setErrors({});
    setShowForm(true);
  };

  // Funzione per aprire il form di modifica
  const handleEdit = (garanzia) => {
    setCurrentGaranzia(garanzia);
    setFormData({
      descrizione: garanzia.descrizione,
      attivo: garanzia.attivo
    });
    setErrors({});
    setShowForm(true);
  };

  // Funzione per eliminare una garanzia
  const handleDelete = async (id) => {
    if (!window.confirm('Sei sicuro di voler eliminare questa garanzia? Questa azione potrebbe influire sulle società di noleggio che la utilizzano.')) {
      return;
    }

    try {
      await api.delete(`/noleggio/garanzie/${id}`);
      fetchGaranzie();
      showNotification('Garanzia eliminata con successo');
    } catch (err) {
      console.error('Errore nell\'eliminazione della garanzia:', err);
      
      if (err.response && err.response.data && err.response.data.message) {
        showNotification(err.response.data.message, 'error');
      } else {
        showNotification('Errore nell\'eliminazione della garanzia', 'error');
      }
    }
  };

  // Gestione cambiamento campi form
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Pulisci l'errore quando l'utente modifica il campo
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  // Validazione form
  const validateForm = () => {
    const newErrors = {};

    if (!formData.descrizione.trim()) {
      newErrors.descrizione = 'La descrizione è obbligatoria';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Invio form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      if (currentGaranzia) {
        // Aggiornamento garanzia esistente
        await api.put(`/noleggio/garanzie/${currentGaranzia.id}`, formData);
        showNotification('Garanzia aggiornata con successo');
      } else {
        // Creazione nuova garanzia
        await api.post('/noleggio/garanzie', formData);
        showNotification('Garanzia creata con successo');
      }
      
      setShowForm(false);
      fetchGaranzie();
    } catch (err) {
      console.error('Errore durante il salvataggio della garanzia:', err);
      
      if (err.response && err.response.data && err.response.data.message) {
        setErrors({ submit: err.response.data.message });
      } else {
        setErrors({ submit: 'Errore durante il salvataggio. Riprova più tardi.' });
      }
    }
  };

  return (
    <div className="bg-gray-50 py-4">
      {/* Notifiche Toast */}
      {notification.show && (
        <div 
          className={`fixed top-4 right-4 z-50 shadow-lg rounded-md px-4 py-3 border-l-4 flex items-start transition-all duration-300 animate-slide-in-right max-w-md ${
            notification.type === 'success' ? 'bg-green-50 text-green-800 border-green-500' :
            notification.type === 'error' ? 'bg-red-50 text-red-800 border-red-500' :
            'bg-blue-50 text-blue-800 border-blue-500'
          }`}
        >
          <div className="mr-3 flex-shrink-0">
            {notification.type === 'success' && (
              <svg className="h-5 w-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            )}
            {notification.type === 'error' && (
              <svg className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
          </div>
          <div className="flex-1">
            <p className="font-medium">{notification.message}</p>
          </div>
          <button 
            className="ml-4 flex-shrink-0 text-gray-400 hover:text-gray-600"
            onClick={() => setNotification(prev => ({ ...prev, show: false }))}
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}

      <div className="max-w-4xl mx-auto px-4">
        {/* Breadcrumb */}
        <nav className="flex mb-6 text-sm" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <Link to="/nlt/" className="inline-flex items-center text-blue-600 hover:text-blue-800">
                Dashboard
              </Link>
            </li>
            <li>
              <div className="flex items-center">
                <svg className="w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
                </svg>
                <Link to="/nlt/societa-noleggio" className="ml-1 text-blue-600 hover:text-blue-800 md:ml-2">
                  Società di Noleggio
                </Link>
              </div>
            </li>
            <li aria-current="page">
              <div className="flex items-center">
                <svg className="w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
                </svg>
                <span className="ml-1 text-gray-500 md:ml-2">Garanzie</span>
              </div>
            </li>
          </ol>
        </nav>

        {/* Titolo e pulsanti */}
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center">
            <Link 
              to="/nlt/societa-noleggio" 
              className="mr-4 p-1.5 text-gray-700 hover:bg-gray-100 rounded-full"
              title="Torna alle società di noleggio"
            >
              <ArrowLeftIcon className="h-5 w-5" />
            </Link>
            <h1 className="text-xl font-semibold text-gray-900">Gestione Garanzie</h1>
          </div>
          <button 
            onClick={handleCreate}
            className="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center text-sm"
          >
            <PlusIcon className="h-4 w-4 mr-1" />
            Nuova Garanzia
          </button>
        </div>

        {/* Lista garanzie */}
        <div className="bg-white shadow-md rounded-md overflow-hidden">
          {loading ? (
            <div className="flex justify-center items-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
              <span className="ml-2 text-gray-600">Caricamento in corso...</span>
            </div>
          ) : garanzie.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              <p className="text-lg">Nessuna garanzia trovata</p>
              <p className="text-sm mt-2">Aggiungi una nuova garanzia per iniziare</p>
            </div>
          ) : (
            <ul className="divide-y divide-gray-200">
              {garanzie.map(garanzia => (
                <li key={garanzia.id} className="px-6 py-4 flex items-center justify-between">
                  <div>
                    <h3 className="text-md font-medium text-gray-900">{garanzia.descrizione}</h3>
                    <p className="text-sm text-gray-500">
                      {garanzia.attivo ? 'Attiva' : 'Inattiva'}
                    </p>
                  </div>
                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleEdit(garanzia)}
                      className="p-1.5 text-blue-600 hover:bg-blue-50 rounded-full"
                      title="Modifica"
                    >
                      <PencilIcon className="h-4 w-4" />
                    </button>
                    <button
                      onClick={() => handleDelete(garanzia.id)}
                      className="p-1.5 text-red-600 hover:bg-red-50 rounded-full"
                      title="Elimina"
                    >
                      <TrashIcon className="h-4 w-4" />
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Form modale per creazione/modifica */}
        {showForm && (
          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4">
              {/* Overlay scuro */}
              <div className="fixed inset-0 bg-black opacity-50" onClick={() => setShowForm(false)}></div>

              {/* Modale */}
              <div className="bg-white rounded-lg shadow-xl max-w-md w-full z-10 relative">
                {/* Intestazione */}
                <div className="flex justify-between items-center border-b px-6 py-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    {currentGaranzia ? 'Modifica Garanzia' : 'Nuova Garanzia'}
                  </h3>
                  <button
                    onClick={() => setShowForm(false)}
                    className="text-gray-400 hover:text-gray-500"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>

                {/* Contenuto form */}
                <div className="px-6 py-4">
                  <form onSubmit={handleSubmit}>
                    {/* Errore generale */}
                    {errors.submit && (
                      <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md border border-red-200">
                        {errors.submit}
                      </div>
                    )}

                    {/* Descrizione */}
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="descrizione">
                        Descrizione *
                      </label>
                      <input
                        type="text"
                        id="descrizione"
                        name="descrizione"
                        value={formData.descrizione}
                        onChange={handleChange}
                        className={`w-full p-2 border rounded-md ${errors.descrizione ? 'border-red-500' : 'border-gray-300'}`}
                        placeholder="Inserisci la descrizione della garanzia"
                      />
                      {errors.descrizione && (
                        <p className="mt-1 text-sm text-red-600">{errors.descrizione}</p>
                      )}
                    </div>

                    {/* Attivo / Inattivo */}
                    {currentGaranzia && (
                      <div className="mb-4 flex items-center">
                        <input
                          type="checkbox"
                          id="attivo"
                          name="attivo"
                          checked={formData.attivo}
                          onChange={handleChange}
                          className="h-4 w-4 text-blue-600 border-gray-300 rounded mr-2"
                        />
                        <label className="text-sm text-gray-700" htmlFor="attivo">
                          Garanzia attiva
                        </label>
                      </div>
                    )}
                  </form>
                </div>

                {/* Footer con bottoni */}
                <div className="px-6 py-3 bg-gray-50 flex justify-end space-x-3 rounded-b-lg">
                  <button
                    type="button"
                    onClick={() => setShowForm(false)}
                    className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
                  >
                    Annulla
                  </button>
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700"
                  >
                    {currentGaranzia ? 'Aggiorna' : 'Crea'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SocietaNoleggioGaranzie; 